import { Modal } from "react-bootstrap-v5";
import { CommunityAdminSimpleAccordion } from "./CommunityAdminSimpleAccordion";
import { useState } from "react";
import { CommunityAdminBanType } from "../enums/CommunityAdminBanType";

type Props = {
    target: 'user' | 'forum';
    id: number;
    username?: string;
    onClose: () => void;
    onBan: (target: 'user' | 'forum', id: number, type: CommunityAdminBanType, reason: string, duration: number) => void;

}

export const CommunityAdminBanModal = ({ id, target, username, onClose, onBan }: Props) => {
    const [type, setType] = useState<CommunityAdminBanType>(CommunityAdminBanType.Temporary);
    const [duration, setDuration] = useState<number>(7);
    const [reason, setReason] = useState('');

    return (
        <Modal show centered size="lg" backdrop="static" dialogClassName="admin-community-ban-modal">
            <h3>
                Suspend or Ban Member
            </h3>
            <h4>
                Your Highness {username || 'Member'}
            </h4>

            <div style={{ display: 'flex', width: '100%', gap: '10px', flexDirection: 'column' }}>
                <CommunityAdminSimpleAccordion 
                    title="Reasons for Permanent Ban"
                    content={
                        <>
                            <p>(Irreversible termination of membership and access to the platform)</p>

                            <ol>
                                <li>
                                    Breach of Confidentiality
                                    <ul>
                                    <li>
                                        Sharing private information about other Members, their families,
                                        or any private Nobilis content, events, or communications.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Fraud or Misrepresentation
                                    <ul>
                                    <li>
                                        Providing false identity, credentials, or professional background
                                        during onboarding or while using the platform.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Harassment or Misconduct
                                    <ul>
                                    <li>
                                        Engaging in any form of abusive, discriminatory, or inappropriate
                                        behavior — online or in person — towards other Members, their
                                        families, partners, or Nobilis staff.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Illegal or Unethical Activities
                                    <ul>
                                    <li>
                                        Use of the platform for money laundering, solicitation, or any form
                                        of criminal or unethical conduct.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Reputational Damage
                                    <ul>
                                    <li>
                                        Actions (public or private) that could materially harm the reputation,
                                        integrity, or security of Nobilis or its Members.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Violation of Nobilis’ Core Values
                                    <ul>
                                    <li>
                                        Persistent behavior contrary to the principles of integrity, respect,
                                        and trust that define the community.
                                    </li>
                                    </ul>
                                </li>

                                <li>
                                    Non-Compliance After Warning
                                    <ul>
                                    <li>
                                        Failure to comply with terms after prior written warnings or temporary
                                        suspensions.
                                    </li>
                                    </ul>
                                </li>
                            </ol>
                        </>
                    }
                />

                <CommunityAdminSimpleAccordion 
                    title="Reasons for Temporary Suspension"
                    content={
                        <>
                            <p>(Access restricted for a limited time pending review or correction)</p>
                            <ol>
                                <li>
                                    Non-Payment or Administrative Issues
                                    <ul>
                                        <li>
                                            Delay or failure to renew membership fees or comply with administrative requirements.
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    Breach of Conduct (Minor or First Instance)
                                    <ul>
                                        <li>
                                            Unintentional or first-time behavior that violates community guidelines but does not warrant a permanent ban.
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    Confidentiality Concerns Under Review
                                    <ul>
                                        <li>
                                            Potential disclosure of sensitive information while Nobilis investigates the matter.
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    Dispute Between Members
                                    <ul>
                                        <li>
                                            Temporary hold during investigation of a reported conflict, complaint, or misunderstanding.
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    Security or Compliance Review
                                    <ul>
                                        <li>
                                            Platform or account flagged for unusual activity, requiring verification.
                                        </li>
                                    </ul>
                                </li>

                                <li>
                                    Host or Partner Misconduct Under Evaluation
                                    <ul>
                                        Pending review of an experience, expert service, or partnership that raised a compliance or ethical question.
                                    </ul>
                                </li>
                            </ol>
                        </>
                    }
                />
            </div>

            <div className="admin-community-ban__selector_wrapper">
                <div className="admin-community-ban__selector_wrapper__selector" onClick={() => setType(CommunityAdminBanType.Temporary)}>
                    { type===CommunityAdminBanType.Temporary ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <rect x="1" y="1" width="16" height="16" rx="8" stroke="#460107" stroke-width="2"/>
                            <rect x="4" y="4" width="10" height="10" rx="5" fill="#460107"/>
                        </svg>
                    ):(
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <rect x="1" y="1" width="16" height="16" rx="8" stroke="#DFDFDF" stroke-width="2"/>
                        </svg>
                    )}

                    <span>
                        Temporary
                    </span>

                    <select value={duration} onChange={(e) => setDuration(Number(e.target.value))}>
                        <option value={7}>1 week</option>
                        <option value={30}>1 month</option>
                        <option value={365}>1 year</option>
                    </select>
                </div>
                <div className="admin-community-ban__selector_wrapper__selector" onClick={() => setType(CommunityAdminBanType.Permanent)}>
                    { type===CommunityAdminBanType.Permanent ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <rect x="1" y="1" width="16" height="16" rx="8" stroke="#460107" stroke-width="2"/>
                            <rect x="4" y="4" width="10" height="10" rx="5" fill="#460107"/>
                        </svg>
                    ):(
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <rect x="1" y="1" width="16" height="16" rx="8" stroke="#DFDFDF" stroke-width="2"/>
                        </svg>
                    )}

                    <span>
                        Permanent
                    </span>
                </div>
            </div>

            <div className="admin-community-ban__reasons">
                <span className="admin-community-ban__reasons_title">Reason for suspension or Banning</span>
                <input type="text" value={reason} onChange={(e) => setReason(e.target.value)}/>
                <span className="admin-community-ban__reasons_metadata">
                    Choose the reason how Member violated <u>Nobilis Code of Conduct</u>
                </span>
            </div>

            <div className="admin-community-ban__actions">
                <button type="button" className="admin-community-ban__actions_secundary" onClick={onClose}>
                    Cancel
                </button>
                <button disabled={!reason} type="button" className="admin-community-ban__actions_primary" onClick={() => onBan(target, id, type, reason, duration)}>
                    Confirm action
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                        <path d="M8.5 0.379395L12 3.38354H0" stroke="white"/>
                    </svg>
                </button>
            </div>
        </Modal>
    )
}